<template>
  <button
    v-b-tooltip.hover
    style="font-size: 11.5px; padding: .40rem;"
    :title="`Enviar por WhatsApp as parcelas selecionadas`"
    class="btn btn-sm btn-outline-primary mr-1"
    @click="openWhatsApp()"
  >
    <font-awesome-icon
      icon="fa-brands fa-whatsapp"
      class="text-primary"
      style="font-size: 18px"
    />
    Enviar por WhatsApp
    <loading
      :show-cancel-button="false"
      :is-loading="isLoading"
      :titulo-carregamento="'Aguarde!'"
      :descricao="`Buscando as parcelas selecionadas.`"
    />
  </button>
</template>

<script>
import moment from 'moment'

export default {
  components: {
    Loading: () => import('@pilar/components/loading/Loading.vue'),
  },
  props: {
    tipoRotina: {
      type: String,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
    linhasSelecionadas: {
      type: Array,
      required: true,
    },
    api: {
      type: Object,
      required: true,
    },
    mensagem: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      mensagemlocal: this.mensagem,
    }
  },
  methods: {
    textoRotina() {
      return this.tipoRotina.toUpperCase()
    },
    openWhatsApp() {
      this.MontarModal()
    },
    MontarModal() {
      if (!this.linhasSelecionadas || this.linhasSelecionadas.length === 0) {
        this.$erro(`Não há nenhuma ${this.textoRotina()} selecionada para download!`)
        return
      }
      this.isLoading = true
      this.api.baixarSelecionados(this.linhasSelecionadas)
        .then(payload => {
          this.isLoading = false
          this.mostrarModalPrincipal(payload.data)
        })
        .catch(err => {
          this.isLoading = false
          this.$erro(`Erro ao encaminhar mensagem via WhatsApp: ${err}.`, err)
        })
    },
    buildMensagem() {
      const quantidade = this.linhasSelecionadas.length
      const texto = quantidade === 1 ? 'da parcela selecionada' : `das ${quantidade} parcelas disponíveis`

      this.mensagem = this.mensagem ?? `Olá, ${this.row.razaoSocial}, segue link para download ${texto}.\r\n\r\nApós baixar, solicitamos que faça a conferência dos dados!\r\n\r\nO link ficará disponível até ${this.getDataVencimento()} `
      return this.mensagem
    },
    getDataVencimento() {
      return moment().add(15, 'days').format('DD/MM/YYYY')
    },
    getMensagemEditavel() {
      // Retorna apenas a parte editável da mensagem (sem a data de vencimento)
      const mensagemCompleta = this.buildMensagem()
      const dataVencimento = this.getDataVencimento()
      return mensagemCompleta.replace(`O link ficará disponível até ${dataVencimento}`, '')
    },
    montarMensagemCompleta(mensagemEditavel) {
      // Monta a mensagem completa com a data calculada pelo sistema
      const dataVencimento = this.getDataVencimento()
      return `${mensagemEditavel}\r\n\r\nO link ficará disponível até ${dataVencimento} `
    },
    editarMensagem(linkArquivo) {
      this.$swal({
        title: '<div class="text-secondary mb-1">Editar Mensagem</div>',
        html: `
          <div class="text-left">
            <label for="mensagem-textarea" class="form-label text-secondary">Mensagem personalizada:</label>
            <textarea 
              id="mensagem-textarea" 
              class="form-control" 
              rows="6" 
              style="resize: vertical; font-size: 14px;"
              placeholder="Digite sua mensagem personalizada..."
            >${this.getMensagemEditavel()}</textarea>
            <div class="mt-2 p-2 bg-light border rounded">
              <small class="text-muted">
                <i class="fa fa-info-circle"></i> <strong>Adicionado automaticamente pelo sistema:</strong><br>
                O link ficará disponível até <strong>${this.getDataVencimento()}</strong><br>
                + Link do arquivo
              </small>
            </div>
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Salvar',
        cancelButtonText: 'Cancelar',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-primary mr-50',
          cancelButton: 'btn btn-outline-secondary mr-50',
        },
        width: 600,
        preConfirm: () => {
          const textarea = document.getElementById('mensagem-textarea')
          const novaMensagem = textarea.value.trim()

          if (!novaMensagem) {
            this.$swal.showValidationMessage('Por favor, digite uma mensagem')
            return false
          }
          return novaMensagem
        },
      }).then(result => {
        if (result.isConfirmed) {
          // Atualiza a mensagem com o novo texto + data calculada pelo sistema
          this.mensagemlocal = this.montarMensagemCompleta(result.value)

          // Abre novamente o modal principal com a mensagem atualizada
          this.mostrarModalPrincipal(linkArquivo)
        }
      })
    },
    mostrarModalPrincipal(linkArquivo) {
      this.$swal({
        width: 680,
        title: '<div class="text-secondary mb-2  mt-1">Envio via WhatsApp</div>',
        html: `
          <textarea readonly class="form-control" rows="6" columns="6">${(this.buildMensagem())} 
          </textarea>
          <div style="text-align: center; margin: 15px 0;">
            <button type="button" id="btn-editar-mensagem" class="btn btn-outline-primary btn-sm">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                
                <path d="m26 -2.5 a2.5 2.5 0 0 1 0 3.5l-15 15-4 1 1-4 15-15a2.5 2.5 0 0 1 3.5 0z"></path>
              </svg>
              Editar
            </button>
          </div>
          <div class="text-primary mb-1 mt-1">
            <a href="${linkArquivo}" target="_blank" class="text-secondary" style="text-decoration: underline;">Link do arquivo</a>
          </div>
        `,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'WhatsApp',
        denyButtonText: 'Copiar link',
        cancelButtonText: 'Cancelar',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-primary mr-50', // WhatsApp azul padrão
          denyButton: 'btn btn-outline-secondary mr-50', // Copiar - Cinza outline
          cancelButton: 'btn btn-outline-danger mr-50', // Cancelar - Vermelho outline
          actions: 'swal2-actions-custom',
        },
        allowOutsideClick: true,
        didOpen: () => {
          // Adiciona funcionalidade ao botão Editar que está entre o textarea e o link
          const btnEditarMensagem = document.getElementById('btn-editar-mensagem')
          if (btnEditarMensagem) {
            btnEditarMensagem.addEventListener('click', () => {
              this.$swal.close()
              this.editarMensagem(linkArquivo)
            })
          }
        },
      }).then(result => {
        if (result.isConfirmed) {
          // WhatsApp foi clicado
          const url = `https://wa.me/?text=${encodeURIComponent(`${this.buildMensagem()}${linkArquivo}`)}`
          window.open(url)
        } else if (result.isDenied) {
          // Copiar link foi clicado
          this.$swal('Copiado!', '', 'success')
          navigator.clipboard.writeText(linkArquivo)
        }
      })
    },
  },
}
</script>
